import { ColorSwatchCategory, hexColorSwatches } from "@nova/constants"
import { encodeColorToNumber } from "@nova/serializer/src/client/util"
import { convertHexStringToRGBArray } from "@nova/util-strings"

export const defaultFirePerimeterColorDeckGL = convertHexStringToRGBArray(
    hexColorSwatches[ColorSwatchCategory.FirePerimeterOutline][0]
)

export const defaultFirePerimeterColor = encodeColorToNumber(
    hexColorSwatches[ColorSwatchCategory.FirePerimeterOutline][0]
)

export const firePerimeterUploadTitle = "Upload Fire Perimeter"
export const firePerimeterAddMoreFilesTitle = "Add More Files"
export const firePerimeterNoPolygonsErrorTitle = "Failed to Read Shape"
